import { makeStyles } from '@material-ui/core/styles';

const BACK_BUTTON_WIDTH = 52;

export const useStyles = makeStyles(() => ({
  additionalLeftPadding: {
    paddingLeft: ({ isBackNavigationEnabled }) => (isBackNavigationEnabled ? BACK_BUTTON_WIDTH : 0)
  }
}));
